// Auth token and device identifier
export const AUTH_TOKEN = "aToken";
export const DEVICE_IDENTIFIER = "deviceidentifier";
export const IS_SUPPORT_LOGIN = 'isSupportLogin';

// Login
export const ACCOUNT_NUMBER = "accountNumber";
export const USER_ID = "userId";

// Redux Store state
export const STATE = "state";

// Outlet Online Status
export const OUTLET_ONLINE_STATUS = "outletOnlineStatus";
export const BRANCH_OUTLET_STATUS = 'branchOutletStatus';

export const APP_SOURCE = "appSource";
export const APP_SOURCE_TYPES = { POS: "pos", RMP: "rmp " };

//DYNAMIC REPORTS
export const DONT_SHOW_FAQ = "dont_show_faq";

//GOOGLE ANALYTICS
export const feature_request = (event: string) => {
  return 'request-feature-' + event;
}

//feature walkthrough
export const RECON_WALKTHROUGH = "RECON_WALKTHROUGH";
//recon file upload modal
export const RECON_FILE_UPLOAD = 'recon_file_upload';

export const FCM_TOKEN = 'fcm_token';